import { CampaignCategoryDto } from '../../../services/Campaign/campaignService.dto';

export const displayCategories = (categoryCodes: string[], availableCategories?: CampaignCategoryDto[]) => {
  if (!availableCategories) return '';
  return availableCategories
    .filter(category => categoryCodes.includes(category.code))
    .map(category => category.displayName)
    .join(', ');
};
